export const HistoryItem = ({ c, showName }) => (
  <article className="pp-hist" data-testid="history-item-card">
    <div className="flex justify-between text-xs gap-2">
      <span className="pp-badge">{showName ? c.profile_name || "Guest" : c.age}</span>
      <span>{new Date(c.created_at).toLocaleString()}</span>
    </div>
    <p className="font-semibold mt-2">“{c.directive}”</p>
    <p className="text-sm mt-1 line-clamp-3 opacity-80">{c.answer}</p>
    <p className="text-xs mt-2 pp-thanks">Said: “{c.thanks}”</p>
  </article>
);
